export default __webpack_public_path__ + "static/media/magnifier.6174e09b.svg";